<template>
  <b-nav-item
    @click="exec"
    :link-classes="linkClasses"
  >
    <b-icon
      v-if="icon"
      :icon="icon"
    />
    <slot />
  </b-nav-item>
</template>

<script>
export default {
  props: {
    routeName: {
      type: String
    },

    action: {
      type: Function
    },

    icon: {
      type: String
    }
  },

  computed: {
    linkClasses () {
      const menuSelected = this.$store.getters[`settings/getAttr`]('menuSelected')
      if (this.routeName === menuSelected) return [ 'item', 'item-selected' ]
      return [ 'item', 'item-default' ]
    }
  },

  methods: {
    exec () {
      if (this.action) this.action()
      if (this.routeName) {
        this.$router.push({ name: this.routeName })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.item {
  font-size: 0.95rem;

  &:hover {
    color: black;
  }

  &-default {
    color: grey;
  }

  &-selected {
    color: #0097e6;
    font-weight: 500;
  }
}
</style>
